var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ingredient-item",on:{"click":function($event){return _vm.$emit('click',_vm.data)}}},[_c('div',{staticClass:"image",style:(_vm.style)}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.data.name))]),(_vm.showFamily)?_c('div',{staticClass:"fam-label"},[_vm._v(_vm._s(_vm.data.family && _vm.data.family.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }